import React, { useState } from "react";
import Spinner from "../../form/Spinner";
import { classNames } from "../../../helpers/classNames";
import Image from "../../elements/Image";
import { checkStartEndDateStatus } from "../../../helpers";
import Badge from "../../elements/Badge";

const OrderSummaryList = ({
  data,
  value = 1,
  setValue = () => {},
  allSold = false,
  ticketLeft = 0,
}) => {
  const startEndDateStatus = checkStartEndDateStatus(
    data?.salesStartDate,
    data?.salesEndDate
  );
  const is_booking_end = checkStartEndDateStatus(
    new Date(),
    data?.bookedPaymentEndDate
  );

  return (
    <div
      className={classNames(
        "relative w-full rounded-xl border border-slate-400 py-4 px-4 divide-y divide-slate-400",
        "bg-white/60"
      )}
    >
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 pb-4">
        <div className="flex items-center gap-2">
          {data?.image?.url && data?.type === "addons-event" && (
            <div className="w-12 aspect-square overflow-hidden border border-slate-100 rounded-md bg-white">
              <Image
                src={data?.image?.url}
                alt="Uploaded Image"
                classes="object-contain"
              />
            </div>
          )}
          <div className="flex-shrink text-slate-900 text-base md:text-lg font-bold">
            {data?.title}
          </div>
        </div>
        <div className="flex-shrink-0">
          {(
            data?.fullPaid === "no"
              ? !is_booking_end?.end
              : // ||
                //   (startEndDateStatus?.start && !startEndDateStatus?.end)
                startEndDateStatus?.start && !startEndDateStatus?.end
          ) ? (
            !allSold ? (
              <div className="flex items-center gap-2">
                {value > 0 && (
                  <button
                    type="button"
                    onClick={() => setValue("reset")}
                    className="flex items-center justify-center capitalize bg-slate-300 px-2 py-1 rounded-md cursor-pointer text-xs font-medium"
                  >
                    reset
                  </button>
                )}
                <Spinner
                  divClasses={
                    "bg-slate-100 rounded-full py-1.5 md:py-2 px-2 md:px-4"
                  }
                  buttonEffect="filled"
                  buttonType="button"
                  value={value}
                  inputClasses="w-14 h-7 md:h-8 border border-gray-300 rounded-md"
                  buttonClasses="w-8 h-7 md:h-8 min-w-[32px] rounded-lg transition-all px-2 text-deep-purple text-sm md:text-base"
                  onChange={(val) => {
                    setValue(parseInt(val));
                  }}
                  isAddDisabled={ticketLeft <= 0}
                />
              </div>
            ) : (
              <div>
                <span className="text-xs text-red-500 font-medium border border-red-500 rounded-md p-1 px-2 bg-red-500/20">
                  SOLD OUT
                </span>
              </div>
            )
          ) : !startEndDateStatus?.start ? (
            <div className="text-xs text-green-500 font-medium border border-green-500 rounded-md p-1 px-2 bg-green-500/20">
              Sale Starts Soon
            </div>
          ) : (
            startEndDateStatus?.end && (
              <div>
                <span className="text-xs text-red-500 font-medium border border-red-500 rounded-md p-1 px-2 bg-red-500/20">
                  Sale Ended
                </span>
              </div>
            )
          )}
        </div>
      </div>
      <div className="relative pt-4">
        <div className="text-slate-900 text-base md:text-lg font-bold">
          <div className="flex items-center gap-2">
            {data?.eventData?.currency?.symbol || "$"} {data?.price}{" "}
            {data?.originalPrice > data?.price && (
              <span className="line-through text-red-500 text-2xl font-medium">
                {data?.eventData?.currency?.symbol || "$"} {data?.originalPrice}
              </span>
            )}
          </div>
          {data?.fee && (
            <span className="text-xs text-slate-500 font-normal">
              +{data?.fee} Fee
            </span>
          )}
        </div>
        {data?.fullPaid === "no" && (
          <div className="grid grid-cols-12 gap-3">
            <div className="text-slate-600 text-sm font-medium col-span-12 lg:col-span-9 flex items-center">
              {data?.info}
            </div>
            <div className="col-span-12 lg:col-span-3 flex items-center lg:justify-end">
              <Badge
                type={is_booking_end?.end ? "danger" : "success"}
                label={is_booking_end?.end ? "BOOKING ENDED" : "BOOKING"}
                className={"text-xs font-medium rounded-md"}
              />
            </div>
          </div>
        )}
      </div>
      {allSold && (
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden border-none">
          <Image
            src={require("../../../assets/images/sold.png")}
            alt={"sold"}
            classes={"object-contain scale-[1.2] opacity-40"}
          />
        </div>
      )}
    </div>
  );
};

export default OrderSummaryList;
